export default {
  login: "moinulhossainmahim",
  id: 68756661,
  node_id: "MDQ6VXNlcjY4NzU2NjYx",
  avatar_url: "https://avatars.githubusercontent.com/u/68756661?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/moinulhossainmahim",
  html_url: "https://github.com/moinulhossainmahim",
  followers_url: "https://api.github.com/users/moinulhossainmahim/followers",
  following_url:
    "https://api.github.com/users/moinulhossainmahim/following{/other_user}",
  gists_url: "https://api.github.com/users/moinulhossainmahim/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/moinulhossainmahim/starred{/owner}{/repo}",
  subscriptions_url:
    "https://api.github.com/users/moinulhossainmahim/subscriptions",
  organizations_url: "https://api.github.com/users/moinulhossainmahim/orgs",
  repos_url: "https://api.github.com/users/moinulhossainmahim/repos",
  events_url:
    "https://api.github.com/users/moinulhossainmahim/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/moinulhossainmahim/received_events",
  type: "User",
  site_admin: false,
  name: "Moinul Hossain",
  company: null,
  blog: "",
  location: "Dhaka, Bangladesh",
  email: null,
  hireable: null,
  bio: null,
  twitter_username: null,
  public_repos: 57,
  public_gists: 0,
  followers: 1,
  following: 6,
  created_at: "2020-07-24T20:44:09Z",
  updated_at: "2022-01-22T16:46:09Z",
};
